import NotificationService from '@/services/NotificationService';

const handleApolloError = (error) => {
  if (error.networkError) {
    NotificationService.showAlert({
      message: 'A network related error has occurred. Please check internet connection and try action again.',
      level: 'error',
      name: 'network',
    });
    return [];
  }
  if (error.graphQLErrors) {
    const errors = error.graphQLErrors.map(e => e.message);
    NotificationService.showAlert({
      message: errors.join('\n'),
      level: 'error',
    });
    return errors;
  }

  NotificationService.showAlert({
    message: 'An unexpected error has occured. Please try again or contact administration.',
    level: 'error',
    name: 'unexpected',
  });
  return [];
};

export default {
  handleApolloError,
};
